export const mesaEntradaTypes = {
  getTramites: '[TRAMITES / MESA] Get Tramites - MesaEntrada',
  cleanTramites: '[TRAMITES / MESA] Clean Tramites - MesaEntrada',
  updateTramite: '[TRAMITES / MESA] Update Tramites - MesaEntrada',

  getDestinos: '[DESTINOS / MESA] Get Destinos - MesaEntrada',
  cleanDestinos: '[DESTINOS / MESA] Clean Destinos - MesaEntrada',

  getTrackingTramitesDestinos:
    '[TRACKING - TRAMITES DESTINOS / MESA] Get Tracking Tramites Destinos - MesaEntrada',
  cleanTrackingTramitesDestinos:
    '[TRACKING - TRAMITES DESTINOS / MESA] Clean Tracking Tramites Destinos - MesaEntrada',
};
